import React, {useState, useContext} from "react"
import CartContext from "../../contexts/CartContext"
import {Table, Button, Icon, Label, Header} from "semantic-ui-react"

let Row = props => {
    let {item, index, onDelete,  ...rest} = props
    return (
      <Table.Row {...rest}>
        <Table.Cell >{item.name}</Table.Cell>
        <Table.Cell>${item.price}.00</Table.Cell>
        <Table.Cell>
          <Button
            className="mobile hidden"
            size="mini"
            inverted
            color="red"
            compact
            circular
            icon='delete'
            floated='right'
            onClick={onDelete}
          />
          <span className="mobile only">
            {"Delete  "}
            <Icon name="delete" color="red" circular onClick={onDelete}/>
          </span>
        </Table.Cell>
      </Table.Row>
    )
}
let OrderDisplay = props=>{
    const {
        nextStep,
    } = props;

    const {cart, setCart} = useContext(CartContext);
    const [setShowMessage] = useState({});

    const emptyCart = ()=>setCart([])

    if (cart.length===0) return <>
      <Header as="h2">Your cart is empty</Header>
      <p>
        Add a Program or Collection
      </p>
    </>
    let total = cart.reduce((sum, item)=>sum+item.price, 0)
  
    let rows = cart.map( (item, index)=>(
      <Row
        key={index}
        item={item}
        onDelete={ ()=>{
          let c = [...cart]
          c.splice(index, 1)
          setCart(c)
          setShowMessage({body: `${item.name} removed from cart.`})
  
        }}
      />
    ))
    return (
    <>
      <Header as="h2">Order</Header>
  
      <Table selectable collapsing >
        <Table.Header className="mobile hidden">
          <Table.Row>
            <Table.HeaderCell>Item</Table.HeaderCell>
            <Table.HeaderCell>Price</Table.HeaderCell>
            <Table.HeaderCell>Remove</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
  
        <Table.Body>
          {rows}
        </Table.Body>
  
        <Table.Footer>
          <Table.Row >
            <Table.HeaderCell style={ {borderTop: "groove"}} >
              <Label ribbon>Total</Label>
            </Table.HeaderCell>
            <Table.HeaderCell style={ {borderTop: "groove"}}>
              <b>${total}.00</b>
            </Table.HeaderCell >
            <Table.HeaderCell style={ {borderTop: "groove"}}/>
          </Table.Row>
        </Table.Footer>
  
      </Table>
      <Button onClick={nextStep}>Checkout</Button>
      <Button onClick={emptyCart}>Empty Cart</Button>
    </>
    )
}

export default OrderDisplay
